export default {
  labels: {
    free_items: 'Articole gratuite',
    bogo: 'Cumperi unul, primești unul gratuit',
    order_again: 'Comandă din nou',
  },
};
